type DeferredSupabaseAuthCallbackWork = () => void | Promise<void>;

function logDeferredWorkError(label: string, error: unknown) {
    if (typeof __DEV__ !== 'undefined' && __DEV__) {
        console.warn(`[SupabaseAuthCallback] Deferred ${label} failed`, error);
    }
}

export function deferSupabaseAuthCallbackWork(
    label: string,
    work: DeferredSupabaseAuthCallbackWork,
): void {
    const run = () => {
        try {
            const result = work();

            if (result && typeof (result as PromiseLike<void>).then === 'function') {
                void Promise.resolve(result).catch((error) => {
                    logDeferredWorkError(label, error);
                });
            }
        } catch (error) {
            logDeferredWorkError(label, error);
        }
    };

    if (typeof setTimeout === 'function') {
        setTimeout(run, 0);
        return;
    }

    void Promise.resolve().then(run);
}
